import moment from "moment/moment";
import api from "./apiURL";

export async function getPaymentList() {
  try {
    const currentSaturday = moment().isoWeekday(6).format("YYYY-MM-DD");
    const response = await api.get(
      `/api/v1/payment/weelycycle/?paymentDate=${currentSaturday}`
    );
    return response.data;
  } catch (error) {
    // Handle the error
    console.log(error);
  }
}

export async function payWeeklyCycle(data) {
  try {
    const response = await api.post(
      `/api/v1/payment/initiateWeeklyPayment`,
      data
    );
    return response.data;
  } catch (error) {
    // Handle the error
    console.log(error);
  }
}

export async function pay(data) {
  try {
    const response = await api.post("/api/v1/payment/initiate", data);
    return response.data;
  } catch (error) {
    // Handle the error
    console.log(error);
  }
}
